import {
  BarChart3,
  Bot,
  CreditCard,
  Link2,
  Image,
  Layers,
  LineChart,
  Mail,
  Megaphone,
  MessageSquare,
  Package,
  Settings,
} from 'lucide-react';

/** Navigation principale (haut de la sidebar) */
export const ADMIN_NAV_GROUPS = [
  {
    id: 'overview',
    label: 'Vue d’ensemble',
    items: [
      { value: 'stats', label: 'Statistiques', icon: BarChart3 },
      { value: 'newsletter', label: 'Newsletter', icon: Mail },
      { value: 'messages', label: 'Messages contact', icon: MessageSquare },
    ],
  },
  {
    id: 'catalog',
    label: 'Catalogue',
    items: [
      { value: 'offers', label: 'Offres', icon: Package },
      { value: 'bundles', label: 'Bundles', icon: Layers },
    ],
  },
  {
    id: 'site',
    label: 'Site & contenu',
    items: [
      { value: 'hero', label: 'Hero', icon: Image },
      { value: 'promo-bar', label: 'Bandeau promo', icon: Megaphone },
    ],
  },
  {
    id: 'integrations',
    label: 'Intégrations',
    items: [
      { value: 'stripe', label: 'Stripe', icon: CreditCard },
      { value: 'wowbooking', label: 'WowBooking', icon: Link2 },
      { value: 'sendgrid', label: 'SendGrid', icon: Mail },
      { value: 'totemium', label: 'Totemium', icon: Bot },
      { value: 'matomo', label: 'Matomo', icon: LineChart },
      { value: 'google-analytics', label: 'Google Analytics', icon: BarChart3 },
    ],
  },
];

/** Entrée fixée en bas de la sidebar */
export const ADMIN_NAV_FOOTER = {
  value: 'config',
  label: 'Configuration',
  icon: Settings,
  description: 'Mot de passe, clés API et paramètres avancés',
};
